import React from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Link from "next/link";

function cookie() {
  const img: any = "/static/images/cookie_bg.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  return (
    <div className="wrapper">
      <Header />

      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Cookies"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-pink mb-4">WHAT ARE COOKIES? </h1>
            </div>
            <div className="col-12 c-content">
              <p className="t-white c-text mb-4">
                Cookies are small data files. When you visit a website, the
                website sends the cookie to your computer. Your computer stores
                it in a file located inside your web browser.
              </p>
              <p className="t-white c-text mb-4">
                Cookies do not transfer viruses or malware to your computer
                because the data in a cookie does not change when it travels
                back and forth, it has no way to affect how your computer runs,
                but they act more like logs (i.e. they record user activity and
                remember stateful information) and they get updated every time
                you visit a website.
              </p>
              <p className="t-white c-text">
                We may obtain information about you by accessing cookies, sent
                by ITP website. Different types of cookies keep track of
                different activities. For example, session cookies are used only
                when a person is actively navigating a website. Once you leave
                the website, the session cookie disappears.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-pink mb-4">WHY ARE COOKIES USEFUL?</h1>
            </div>
            <div className="col-12 c-content">
              <p className="c-text mb-4">
                ITP website uses functional cookies to analyses how visitors use
                our website, track and improve our website’s functions and
                performance. The activity allows us to provide a good customer
                experience to visitor by identifying and fixing any issues that
                may happen, such as using cookies to keep track of which website
                pages are most popular and which method of linking between
                website pages is most effective. The latter also helps us to
                track if you were referred to us by another website and improve
                our future advertising activities.
              </p>
              <p className="c-text mb-4">
                Another use of cookies is to store your log in sessions. If
                website has log in function, when you log in to the Members
                Area, a "session cookie" is set so that the website remembers
                that you have already logged in. If the website did not set this
                cookie, you will be asked for your login and password on each
                new page as you progress through website.
              </p>
              <p className="c-text mb-4">
                In addition, functional cookies, for example, are used to allow
                us to remember your preferences and identify you as a user,
                ensure your information is secure and operate more reliably and
                efficiently. For example, cookies save you the trouble of typing
                in your username every time you access our website, and recall
                your preferences, such as which language you wish to see when
                you log in.
              </p>

              <p className="c-text mb-4">
                Our cookies provides us the following:
              </p>
              <ul className="mb-5">
                <li className="c-text mb-1">
                  Detecting the country you are currently visiting from
                </li>
                <li className="c-text mb-1">
                  Checking browser type and device
                </li>
                <li className="c-text mb-1">
                  Tracking which site the user was referred from
                </li>
                <li className="c-text mb-1">
                  Allowing third parties to customize content accordingly
                </li>
              </ul>

              <p className="c-text mb-2">
                ITP website uses Google Analytics, a web analytics service
                provided by Google, Inc.. Google Analytics uses analytical
                cookies placed on your computer, to help us analyze a user's use
                of the website. The information generated by the cookie about
                your website usage (including your IP address) may be
                transmitted to Google, Inc. and stored on their servers. Google,
                Inc. may use this information to evaluate your website usage, to
                make reports about website activity and to provide other
                services related to website activity and internet usage. Google,
                Inc. may also transfer this information to third parties, where
                required to do so by law, or where such third parties process
                the information on behalf of Google. Google, Inc. will not
                associate your IP address with any other data held. By using ITP
                website, you give your consent to Google, Inc. to process data
                about you in the manner and for the purposes set out above.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-pink mb-4">
                TYPE OF COOKIES THAT MIGHT BE STORED ON YOUR DEVICE
              </h1>
            </div>
            <div className="col-12 c-content">
              <p className="t-pink c-text mb-2">Functional cookies</p>
              <p className="t-white c-text mb-5">
                These cookies are necessary to performing the best performance
                of our website. Without these cookies our websites would not
                function properly. These cookies allow a website to remember
                choices you have made in the past such as the language you
                prefer, your user name and password in case the website need
                logging in, you can automatically log in etc..
              </p>

              <p className="t-pink c-text mb-2">Analytical cookies</p>
              <p className="t-white c-text mb-5">
                Analytical cookies are important in measuring the performance of
                a website and optimizing it. These cookies are information about
                visitors’ behavior on a webpage during a visit. It used to
                determine website usage and may be used to track an individual
                users, but only to the extent to allow users journey through the
                site. Analytical cookies collect statistical, not personal
                information to help improving website performance, user
                experience or speed of the page.
              </p>

              <p className="t-pink c-text mb-2">Marketing cookies</p>
              <p className="t-white c-text mb-5">
                These cookies are used to track visitors across websites for the
                purpose of delivering advertising that is relevant to the
                individual user and displaying advertising that is more valuable
                for publishers and third party advertisers.
              </p>

              <p className="t-pink c-text mb-2">Targeting Cookies</p>
              <p className="t-white c-text mb-5">
                These cookies are used to deliver the content which best suits
                you and your interests. Targeting Cookies can be used for
                targeting advertisement, limiting ad delivering or measuring
                promotional campaign effectiveness.
              </p>

              <p className="t-pink c-text mb-2">Preferences cookies</p>
              <p className="t-white c-text mb-5">
                Preference cookies enable a website to remember information that
                changes the way the website behaves or looks, like your
                preferred language or the region that you are in.
              </p>

              <p className="t-pink c-text mb-2">Session cookies</p>
              <p className="t-white c-text">
                These cookies are used only when a person is actively navigating
                a website. Once you leave the website, the session cookie
                disappears.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-pink mb-4">DISABLING COOKIES</h1>
            </div>
            <div className="col-12 c-content">
              <p className="c-text mb-4">
                Cookies are small data files that can be used by websites to
                make a user's experience more efficient. The law states that we
                can store cookies on your device if they are strictly necessary
                for the operation of this site. For all other types of cookies
                we need your permission. This site uses different types of
                cookies. Some cookies are placed by third party services that
                appear on our pages.
              </p>
              <p className="c-text mb-4">
                Most of web browsers are set up to accept cookies. You may be
                able to set your browser to warn you before accepting certain
                cookies or to refuse certain cookies. However, if you disable
                the use of cookies in your web browser, some services and
                functions of ITP website may be difficult to be used or may not
                function correctly, and you may have to manually adjust some
                preferences every time you visit our website. We use cookies to
                optimize your user experience on our website. For a full website
                experience, please accept our cookies policy.
              </p>
              <p className="c-text mb-4">
                To find out about how to disable cookies, please refer to the
                following.
              </p>

              <a
                href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"
                className="t-darkblue c-text mb-0 d-inline-block"
              >
                IE
                https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies
              </a>
              <a
                href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en"
                className="t-darkblue c-text mb-0 d-inline-block"
              >
                Chrome
                https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en
              </a>

              <a
                href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                className="t-darkblue c-text mb-4 d-inline-block"
              >
                Firefox
                https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences
              </a>

              <p className="c-text mb-4">
                You can at any time change or withdraw your consent from the
                Cookie Declaration on our website
              </p>
              <p className="c-text mb-4">
                Learn more about how to use this website in our Terms and
                Conditions and how we process personal data in our
                <Link href="/privacypolicy" className="t-darkblue c-text">
                  {" "}
                  Privacy Policy.
                </Link>
              </p>
              <p className="c-text mb-4">
                Your consent applies to the following domains:
                <Link href="/" className="t-darkblue c-text">
                  {" "}
                  http://www.itp.co.th/
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default cookie;
